export const FONT_FAMILY = "Alma Inter";

// The latin subset covers all the supported locales
const FONT_URL = "https://cdn.almapay.com/fonts/Inter/InterVariable-latin.woff2";
// Waiting longer would delay the payment plan more than a font swap would hurt
const MAX_FONT_WAIT = 300;

let fontLoading: Promise<unknown> | null = null;

/**
 * Fonts declared inside a shadow root are ignored by browsers,
 * so the font is registered on the merchant's document, under a name of our own.
 */
export function loadFont() {
  // Missing in some environments, e.g. jsdom in merchants' unit tests
  if (fontLoading || typeof FontFace === "undefined" || !document.fonts) return;

  const fontFace = new FontFace(FONT_FAMILY, `url(${FONT_URL}) format("woff2")`, {
    weight: "400 700",
    display: "swap",
  });
  document.fonts.add(fontFace);
  fontLoading = fontFace.load().catch((error) => {
    console.error("[Alma InPage] Failed to load the font:", error);
  });
}

/**
 * Resolves when the font is ready, or after MAX_FONT_WAIT: the plan then shows with the fallback font
 */
export function waitForFont() {
  return Promise.race([
    fontLoading,
    new Promise((resolve) => setTimeout(resolve, MAX_FONT_WAIT)),
  ]);
}
